<template>
    <layout title="Users">
        <div class="flex flex-col">
            <div v-if="! showFilter" class="w-full flex justify-end text-sm font-semibold mb-2 text-blue-800">
                <a href="#" @click.prevent="showFilter = true" class="flex items-center">
                    <svg class="w-5 h-5 mr-1 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"></path></svg>
                    <span>Search and Filter</span>
                </a>
            </div>
            <div v-if="showFilter" class="flex p-4 py-8 rounded-lg bg-blue-50 mb-8 relative">
                <svg @click="showFilter = false" class="h-5 h-5 absolute top-0 right-0 mr-2 text-blue-800 mt-2 cursor-pointer" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                <div class="w-2/3 pr-4">
                    <div class="mt-1 relative rounded-md shadow-sm">
                        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
                        </div>
                        <input v-model="searchText" type="text" name="search" id="search" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full p-3 font-mono pl-12  border-gray-300 rounded-md" placeholder="Search...">
                    </div>
                </div>

                <div class="w-1/3 pl-4">
                    <select v-model="showRoles" id="location" name="location" class="mt-1 block w-full pl-3 pr-10 py-3 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 font-mono rounded-md">
                        <option value="all" slected>Show all roles...</option>
                        <option v-for="role in roles" :key="role.id" :value="role.name">{{ role.name }}</option>
                    </select>
                </div>

            </div>

            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="overflow-x-hidden border-b border-gray-200">
                        <table class="min-w-full divide-y divide-gray-200 pb-24">
                            <thead>
                                <tr>
                                    <th @click="sortBy('name')" :class="{'font-extrabold' : sortKey === 'name' }" scope="col" class="cursor-pointer px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        <div class="cursor-pointer flex items-center justify-between">
                                            <span>Name</span>
                                            <span v-if="sortKey === 'name'">
                                                <svg :class="{'transform rotate-180' : sortOrder === 'desc' }" class="w-4 h-4 ml-1 transition duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"></path></svg>
                                            </span>
                                        </div>
                                    </th>
                                    <th @click="sortBy('phone')" :class="{'font-extrabold' : sortKey === 'phone' }" scope="col" class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        <div class="cursor-pointer flex items-center justify-between">
                                            <span>Phone</span>
                                            <span v-if="sortKey === 'phone'">
                                                <svg :class="{'transform rotate-180' : sortOrder === 'desc' }" class="w-4 h-4 ml-1 transition duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"></path></svg>
                                            </span>
                                        </div>
                                    </th>
                                    <th @click="sortBy('email')" :class="{'font-extrabold' : sortKey === 'email' }" scope="col" class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        <div class="cursor-pointer flex items-center justify-between">
                                            <span>Email</span>
                                            <span v-if="sortKey === 'email'">
                                                <svg :class="{'transform rotate-180' : sortOrder === 'desc' }" class="w-4 h-4 ml-1 transition duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"></path></svg>
                                            </span>
                                        </div>
                                    </th>
                                    <th @click="sortBy('username')" :class="{'font-extrabold' : sortKey === 'username' }" scope="col" class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        <div class="cursor-pointer flex items-center justify-between">
                                            <span>Username</span>
                                            <span v-if="sortKey === 'username'">
                                                <svg :class="{'transform rotate-180' : sortOrder === 'desc' }" class="w-4 h-4 ml-1 transition duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"></path></svg>
                                            </span>
                                        </div>
                                    </th>
                                    <th @click="sortBy('role')" :class="{'font-extrabold' : sortKey === 'role' }" scope="col" class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        <div class="cursor-pointer flex items-center justify-between">
                                            <span>Role</span>
                                            <span v-if="sortKey === 'role'">
                                                <svg :class="{'transform rotate-180' : sortOrder === 'desc' }" class="w-4 h-4 ml-1 transition duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"></path></svg>
                                            </span>
                                        </div>
                                    </th>
                                    <th scope="col" class="px-6 py-3 pr-4 bg-gray-50 text-right">
                                        <inertia-link :href="route('users.create')" class="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border text-sm font-medium rounded-md text-blue-50 bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500">
                                            <span>Add User</span>
                                        </inertia-link>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- Odd row -->
                                <tr v-for="(user, idx) in filteredUsers" :key="user.id" :class="idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'" class="transition duration-500">
                                    <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                        {{ user.name }}
                                    </td>
                                    <td class="font-mono px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        {{ user.phone }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        {{ user.email }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        {{ user.username }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                        <span class="inline-flex items-center">
                                            <svg :class="{
                                                'text-red-400' : user.role_id === $SUPER_ADMIN_ROLE,
                                                'text-yellow-400' : user.role_id === $ADMIN_ROLE,
                                                'text-indigo-400' : user.role_id === $GIN_ROLE,
                                                'text-green-400' : user.role_id === $CUSTOMER_ROLE
                                                }" class="-ml-0.5 mr-1.5 h-2 w-2" fill="currentColor" viewBox="0 0 8 8">
                                                <circle cx="4" cy="4" r="3" />
                                            </svg>
                                            {{ user.role }}
                                        </span>
                                    </td>
                                    <td class="px-6 py-4 align-top text-right text-sm font-medium">

                                        <div class="relative inline-block text-left">
                                            <div>
                                                <button @click="setShowMenu(user.id)" class="w-8 h-8 inline-flex items-center justify-center text-gray-400 rounded-full hover:text-gray-500 focus:outline-none" id="options-menu" aria-haspopup="true" aria-expanded="true">
                                                    <span class="sr-only">Open options</span>
                                                    <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                                        <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                                    </svg>
                                                </button>
                                            </div>
                                            <div v-if="user.id === showMenu" class="origin-top-right absolute z-10 right-0 top-0 mr-8 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                                                <div class="py-1" role="none">
                                                    <inertia-link :href="route('impersonate', user.id)" class="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">
                                                        <svg class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" stroke-linecap="round" stroke-linejoin="round"></path>
                                                        </svg>
                                                        Impersonate
                                                    </inertia-link>
                                                </div>
                                                <div class="py-1" role="none">
                                                    <inertia-link :href="route('users.profile', user.id)" class="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">
                                                        <svg class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                                            <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                                                            <path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clip-rule="evenodd" />
                                                        </svg>
                                                        Edit
                                                    </inertia-link>
                                                </div>
                                                <div class="py-1 border-t border-gray-100" role="none">
                                                    <remove-user @close-menu="showMenu = null" :item="user"></remove-user>
                                                </div>
                                            </div>
                                        </div>

                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    </layout>
</template>

<script>
import Layout from '@/Shared/Layout'
import RemoveUser from '@/Components/Users/RemoveUser'

export default {
    components: {
        Layout, RemoveUser
    },
    metaInfo() {
        return {
            title: `Users`,
        }
    },
    props: {
        users: Array,
        roles: Array,
    },
    data() {
        return {
            showMenu: null,
            sortKey: 'name',
            sortOrder: 'asc',
            showRoles: 'all',
            searchText: '',
            showFilter: false
        }
    },
    methods: {
        setShowMenu(id) {
            this.showMenu = this.showMenu === id ? null : id
        },
        sortBy(key) {
            this.sortKey = key
            this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
        },
        compareValues(key, order = 'asc') {
            return function innerSort(a, b) {
                if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) return 0;
                const comparison = a[key].localeCompare(b[key]);

                return (
                    (order === 'desc') ? (comparison * -1) : comparison
                );
            };
        }
    },
    watch: {
        showFilter() {
            if (! this.showFilter) {
                this.searchText = ''
            }
        }
    },
    computed: {
        sortedUsers() {
            let users = this.users

            if (this.showRoles !== 'all') {
                users = users.filter(u => u.role === this.showRoles)
            }

            return users.sort(
                this.compareValues(this.sortKey, this.sortOrder)
            )
        },
        filteredUsers() {
            const search = this.searchText.toLowerCase().trim()

            if (!search) return this.sortedUsers

            return this.sortedUsers.filter(function(row) {
                return Object.keys(row).some(function(key) {
                    return (
                        String(row[key])
                            .toLowerCase()
                            .indexOf(search) > -1
                    )
                })
            })
        }

    }
}
</script>
